export const theme = {
  primary: '#000000', 
  secondary: '#888888', 
  accent: '#ffffff', 
  accentGlow: 'rgba(255, 255, 255, 0.12)',
  background: '#050505', 
  cardBackground: 'rgba(255, 255, 255, 0.04)', 
  text: '#b0b0b0', 
  lightGray: '#f0f0f0', 
  darkGray: '#1a1a1a', 
  white: '#ffffff',
  gradient: 'linear-gradient(135deg, #050505 0%, #111111 50%, #050505 100%)',
  shadow: '0 10px 30px -15px rgba(0, 0, 0, 0.6)',
  glassShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)',
  glassBorder: '1px solid rgba(255, 255, 255, 0.08)',
  glassBackground: 'rgba(10, 10, 10, 0.7)',
  transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
  borderRadius: '16px',
  navHeight: '70px',
  navScrollHeight: '60px',
  fontPrimary: "'Inter', 'Calibre', -apple-system, system-ui, sans-serif",
  fontMono: "'Fira Code', 'Fira Mono', monospace",

  // Consistent section spacing
  sectionPadding: {
    mobile: '80px 20px',
    tablet: '100px 40px',
    desktop: '120px 60px',
  },

  // Breakpoints
  bp: {
    mobileS: '375px',
    mobileM: '425px',
    mobileL: '480px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1440px',
    desktop: '2560px'
  }
};